var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPositions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 455 455",
    style: {
      enableBackground: "new 0 0 455 455"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M270.141,227.5c0-18.235-11.508-33.826-27.641-39.909v79.818C258.632,261.326,270.141,245.735,270.141,227.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 173.5,
    width: 55,
    height: 108
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.859,227.5c0,18.235,11.508,33.826,27.641,39.909v-79.818C196.368,193.674,184.859,209.265,184.859,227.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.5,71.5v84.926c32.88,6.931,57.641,36.162,57.641,71.074s-24.76,64.143-57.641,71.074V383.5H455v-72h-85v-168h85v-72 H242.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,143.5h85v168H0v72h212.5v-84.926c-32.88-6.931-57.641-36.162-57.641-71.074s24.76-64.143,57.641-71.074V71.5H0V143.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 173.5,
    width: 55,
    height: 108
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositions);
export default __webpack_public_path__ + "static/media/positions.f747720b9659b008205d7285ebe80095.svg";
export { ForwardRef as ReactComponent };